export default "/images/1a790d90aee3b8439f85bd32e96e2764.avif";